import { Component, createSignal } from "solid-js";
import DefaultAcordeon from "./DefaultAcordeon";
import Styles from "bundle-text:../styles/_connectionType.scss";
import { translations as t } from "../../../services/context";

interface ConnectionTypeProps {
  onSelect: (type: string) => void;
}

const ConnectionType: Component<ConnectionTypeProps> = (props) => {
  const [selectedType, setSelectedType] = createSignal<string | null>(null);

  const handleSelect = (type: string) => {
    setSelectedType(type);
    props.onSelect(type);
  };

  return (
    <>
      <style>{Styles}</style>
      <DefaultAcordeon title={t["dns_connection_type"]} isOpen={true}>
        <ul class="connection-type-list">
          <li
            classList={{ selected: selectedType() === "change_nameserver" }}
            onClick={() => handleSelect("change_nameserver")}
          >
            <input
              type="radio"
              name="connection-type"
              checked={selectedType() === "change_nameserver"}
            />
            <span>{t["dns_change_nameserver"]}</span>
          </li>
          <li
            classList={{ selected: selectedType() === "keep_external" }}
            onClick={() => handleSelect("keep_external")}
          >
            <input
              type="radio"
              name="connection-type"
              checked={selectedType() === "keep_external"}
            />
            <span>{t["dns_keep_external"]}</span>
          </li>
        </ul>
      </DefaultAcordeon>
    </>
  );
};

export default ConnectionType;
